import * as _ from 'underscore';
import * as $ from 'jquery';

import { validators as AppValidators } from '../../../../_common/application/ts/validators';
//import GlobalState = require('../../../../_common/application/ts/namespace-business-intelligence/GlobalState');

import * as Config from '../config';

import { IDataQuery } from './Interfaces';

import { bandsHaveCyclicRefs } from '../../../../_common/platform/tsx/GridBandField';

import { NONE } from '../../../../_common/platform/ts/ConfigurationConstants';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

const NUMBERS_AND_LETTERS_REGEXP = /^(auto|0)$|^[+]?[0-9]+.?([0-9]+)?(px|em|ex|%|in|cm|mm|pt|pc)$/;

export var length = {
    pixel_percent: function (value) {
        if (!NUMBERS_AND_LETTERS_REGEXP.test(value)) {
            return ['Should contain positive numbers and letters'];
        }
    }
};

//LL: 17.10.24:
export const validatorsTreeList = {
    attrquery_data: {
        notEmpty: function (value: any) {
            if (value.attrQuery == null || value.attrQuery.length === 0) {
                return ['At least one attribute should be specified'];
            }
        },
        //LL: 04.12.24: dataGroup is not inside groupingOptions, so can not use roleUnique
        roleUnique_dataGroup: function (value: any) {
            if (value.attrQuery != null || value.attrQuery.length > 0) {
                let count = _.countBy<any>(value.attrQuery, (obj: any) => {
                    let role = obj.role;
                    return role || 'none';
                });
                if (count.dataGroup > 1) {
                    return ['Data Tree Attribute must be only one'];
                }
            }
        },
        roleUnique: function (RoleList: any) { // for inside groupingOptions.isParentAttr  isNameAttr  isIdAttr
            return function (value: any) {
                if (value.isTree !== true) {
                    return;
                }
                let resCount = {};
                _.each(RoleList, (r: any) => {
                    let count = _.countBy<any>(value.attrQuery, (obj: any) => {
                        let groupingOptions = obj.groupingOptions || {};
                        return groupingOptions[r] || 'none';
                    });
                    resCount[r] = {role: r, count: count, cnt: count == null ? 0 : count.true};
                });

                let filter = _.filter<any>(resCount, (res: any) => {
                    if (res.cnt == null) {
                        return false;
                    }
                    return res.cnt > 1;
                });
                if (filter.length > 0) {
                    let ret = _.map(filter, (f: any) => {
                        return ['Role ' + f.role + ' can be set only once'];
                    });
                    return ret;
                }

                // let find = _.find<any>(resCount, (res: any) => {
                //     if (res.cnt == null) {
                //         return false;
                //     }
                //     return res.cnt > 1;
                // });
                // if (find != null) {
                //     return ['Role ' + find.role + ' can be set only once'];
                // }
            };
        },
        roleRequire: function (RoleList: any) {
            // groupingOptions.isParentAttr  isNameAttr  isIdAttr
            return function (value: any) {
                if (value.isTree !== true) {
                    return;
                }
                let resCount = {};
                _.each(RoleList, (r: any) => {
                    let count = _.countBy<any>(value.attrQuery, (obj: any) => {
                        let groupingOptions = obj.groupingOptions || {};
                        return groupingOptions[r] || 'none';
                    });
                    resCount[r] = {role: r, count: count, cnt: count == null ? 0 : count.true};
                });

                let filter = _.filter<any>(resCount, (res: any) => {
                    return res.cnt == null || res.cnt === 0;
                });
                if (filter.length > 0) {
                    let ret = _.map(filter, (f: any) => {
                        return ['Role ' + f.role + ' must be specified when "isTree" is set'];
                    });
                    return ret;
                }
            };
        },
        //LL: 23.01.25:
        editingRequireDataGroupAttr: function (theme: any) {
            return function (value: any) {
                if (theme == null) {
                    return;
                }
                if (theme[Config.themeFields.edit_DataEditDialogID_Inserting] == null &&
                    theme[Config.themeFields.edit_DataEditDialogID_Updating] == null &&
                    theme[Config.themeFields.edit_allowDeleting] !== true) {
                    return;
                }
                if (value.attrQuery != null || value.attrQuery.length > 0) {
                    let count = _.countBy<any>(value.attrQuery, (obj: any) => {
                        let role = obj.role;
                        return role || 'none';
                    });
                    if (count.dataGroup == null || count.dataGroup == 0) {
                        return ['Data Tree Attribute must be defined when Editing is allowed'];
                    }
                }
            };
        }
    }
};

//LL: 25.05.21
export function validateBands(value: IDataQuery) {
    if (value != null) {
        const bands = value.bands;

        const numberOfBands = bands != null ? bands.length : 0;
        if (numberOfBands === 0) {
            return null;
        }

        let hasCyclicRefs = bandsHaveCyclicRefs(bands);
        
        if (hasCyclicRefs) {
            return ['Bands have cyclic references'];
        }

        return null;
    }

    return null;
}

export function validateGroupingAttributes(value: IDataQuery) {
    if (value != null) {
        const attrQueries = value.attrQuery;

        const numberOfAttributes = attrQueries != null ? attrQueries.length : 0;
        if (numberOfAttributes === 0) {
            return null;
        }

        if (value.endlessScrolling === true) {
            const attributeWithSortingExists = _.some(value.attrQuery, (attr) => {
                return attr.sort != null && attr.sort !== NONE;
            });

            if (!attributeWithSortingExists) {
                return ['When Endless Scrolling is on, at least one Attribute must be sorted'];
            }
        }

        return AppValidators.attributesParameterField.validateGroupingAttributes(value);
    }

    return null;
}

export function validateDataLimit(value: IDataQuery) {
    if (value != null) {
        if (value.endlessScrolling === true && value.limit < 100) {
            return ['When Endless Scrolling is on, the amount of records to retch must be at least 100'];
        } else {
            return null;
        }
    }

    return null;
}

export function fix(value: IDataQuery, widgetData: any, glob: IGlob): IDataQuery {
    if (value.endlessScrolling === true) {
        // if (value.limit < 100) {
        //     glob.AppActions.showNotification_Warning(
        //         'Erros in "' + (widgetData.name || '') + '" widget configuration.<br/><br/>\n' +
        //         'When Endless Scrolling is on, the amount of rows to fetch must be equal or more than 100.<br/>\n' +
        //         'This parameter is changed to do not block widget execution.<br/>\n' +
        //         'Please, verify and fix widget configuration',
        //         null,
        //         {
        //             manualDestroy: true
        //         }
        //     );

        //     var newval = $.extend(
        //         true,
        //         {},
        //         value,
        //         {
        //             limit: 100
        //         }
        //     )

        //     return newval;

        // }

        let attributeWithSortingExists: boolean = _.some(value.attrQuery, (attr) => {
            return attr.sort != null && attr.sort !== NONE;
        });

        if (!attributeWithSortingExists) {
            glob.AppActions.showNotification_Fail(
                'Erros in "' +
                    (widgetData.name || '') +
                    '" widget configuration.<br/><br/>\n' +
                    'When Endless Scrolling is on, at least one Attribute must be sorted.<br/>\n' +
                    'The "EndlessScrolling" parameter is turned OFF in configuration to do not block widget execution.<br/>\n' +
                    'Please, verify and fix widget configuration',
                null
            );

            return $.extend(true, value, {
                endlessScrolling: false
            });
        } else {
            return value;
        }
    } else {
        return value;
    }
}

